import * as React from 'react'
import BaseIcon from 'react-icon-base'

import { EColors } from 'app/constants/colors'
import { IIconProps } from './interface'

const ReplaceIcon = (props: IIconProps) => (
  <BaseIcon width="15" height="16" viewBox="0 0 15 16" {...props}>
    <path
      d="M3.766 7.508V4.372h7.802v2.333l3.1-3.099-3.1-3.098V2.84H2.235v4.667h1.53zm0 8.53v-2.333h9.333V9.038h-1.53v3.136H3.765V9.841L.667 12.94l3.099 3.098z"
      fill={`${EColors.BLUE}`}
      fillRule="nonzero"
    />
  </BaseIcon>
)

export default ReplaceIcon
